import { combineReducers } from 'redux';
import itemListing from './itemMaintenance/reducer';
import settings from './settings/reducer';
import addEditItem from './addEditItem/reducer';
import itemStorageLocation from './itemStorageLocation/reducer';
import updateBidPriceDetails from './updateBidPriceDetails/reducer';

export default combineReducers({
  itemListing,
  settings,
  addEditItem,
  itemStorageLocation,
  updateBidPriceDetails,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/reducer.js